import { useEffect } from 'react';

import './Sboard.css'
import { ReactComponent as X } from './images/X.svg';
import { ReactComponent as O } from './images/O.svg';

function Sboard(props) {

  // console.log('sboard');
  // console.log(props);

  useEffect(
    () => {
      setBoardSize();

      window.addEventListener('resize', setBoardSize);

      return () => window.removeEventListener('resize', setBoardSize);
    },
    [],
  );

  let map = {
    '-': null,
    'O': <O />,
    'X': <X />,
  }

  // let map = {
  //   '-': null,
  //   'O': 'O',
  //   'X': 'x',
  // }

  let currentRepresentation = props.currentRepresentation;
  let lastMove = props.lastMove;
  let onClickAction = props.onClickAction;
  let ub = props.ub;
  let isAllowedClassName = props.isAllowedClassName; // X , O, null
  let bigResultDisplay = props.bigResultDisplay; // X, O, -
  let boardElements = [];

  for (let i = 0; i < 3; i++) {
    for (let j = 0; j < 3; j++) {
      let lastClassName = '';
      if (lastMove && i === lastMove[0] && j === lastMove[1]) {
        lastClassName = 'last-move';
      }
      let elm = <div key={`s${i}${j}`} className={`s${i}${j} ${lastClassName}`} onClick={() => onClickAction(ub[0], ub[1], i, j)}>
        {map[currentRepresentation[i][j]]}
      </div>;

      boardElements.push(elm);
    }
  }

  return (
    <div className="Sboard">
      <div className={`sboard-container ${isAllowedClassName}`}>
        {boardElements}
      </div>
      <div className='sboard-result'>
        {map[bigResultDisplay]}
      </div>
    </div>
  );

}

export default Sboard;


function setBoardSize() {
  let displayWidth = Math.min(
    document.body.scrollWidth, document.documentElement.scrollWidth,
    document.body.offsetWidth, document.documentElement.offsetWidth,
    document.body.clientWidth, document.documentElement.clientWidth
  );
  let mysize = displayWidth;
  if (mysize >= 300) {
    mysize = 300
  }

  let sSize = mysize * .9;

  let squareSize = (sSize / 3);

  let sboard = document.querySelector('.sboard-container');
  sboard.style.width = sboard.style.height = sSize + 'px';

  let squares = document.querySelectorAll('.sboard-container > div');
  for (let square of squares) {
    square.style.width = square.style.height = squareSize + 'px';
  }
}
